import { render, staticRenderFns } from "./products-and-plans.vue?vue&type=template&id=0ac9ae1b&"
import script from "./products-and-plans.vue?vue&type=script&lang=js&"
export * from "./products-and-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports